import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./client";
import { ME_KEY, type User } from "./auth";

/** Egy projekt (alkalmazás) a platformon — rendszerterv 4. */
export interface Project {
  slug: string;
  name: string;
  lead: string;
  app_path: string;
  registration_open: boolean;
  is_member: boolean;
}

export const PROJECTS_KEY = ["projects"] as const;

export function useProjects() {
  return useQuery({
    queryKey: PROJECTS_KEY,
    queryFn: () => api<Project[]>("/projects"),
    staleTime: 5 * 60 * 1000,
  });
}

/** Csatlakozás meglévő fiókkal: csak a projekt saját kérdéseit kell megválaszolni. */
export function useJoinProject(slug: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (answers: Record<string, unknown>) =>
      api<Project>(`/projects/${slug}/join`, { method: "POST", body: { answers } }),
    onSuccess: async () => {
      const me = await api<{ user: User }>("/auth/me");
      qc.setQueryData(ME_KEY, me.user);
      await qc.invalidateQueries({ queryKey: PROJECTS_KEY });
    },
  });
}

/** Tagja-e a felhasználó a projektnek (az admin mindenhez hozzáfér). */
export function isMember(user: User | null | undefined, slug: string): boolean {
  if (!user) return false;
  return user.role === "admin" || user.projects.some((p) => p.slug === slug);
}
